import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  loading: false,
  exportLoading: false,
  error: false,
  success: false,
  suggestedprovident: false,
  transactionSPA: [],
  suggestedPF: [],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/SuggestedPF/index.js